<template>
    <div class="video-section">
        <div class="video-field display-flex">
            <div class="label-width">
                <div class="label-icon"><i class="fas fa-film"></i></div>
                <div class="label-text">Video</div>
            </div>
            <div class="label-field">
                <vue-plyr v-if="hasVideo">
                    <video :src="video"></video>
                </vue-plyr>
                <div class="video-files" v-else>No Video File!</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { VuePlyr } from 'vue-plyr'
    export default {
        plugins: [
            '~/plugins/vue-plyr'
        ],
        css: [
            'vue-plyr/dist/vue-plyr.css'
        ],
        props: ['car'],
        components: {
            VuePlyr
        },
        data () {
            return {
                video: null
            }
        },
        computed: {
            hasVideo() {
                if (this.video) {
                    return true
                }
            }
        },
        created () {
            this.video = this.car.media.video
        }
    }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Cars/Car/VideoBox.vue